<template>
    <b-badge :variant="color">{{ text }}</b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue';

export default{
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:[Object,String,Array,Number]
    },
    computed:{
        text(){
            if(this.row.Status == 'B') return 'Bitti'
            else if(this.row.Status == 'DU') return 'Dolmak Üzere'
            else if(this.row.Status == 'Y') return 'Yaklaşıyor'
            else if(this.row.Status == 'DE') return 'Devam Ediyor'
            else return 'Bilinmiyor'
        },
        color(){
            if(this.row.Status == 'B') return 'danger'
            else if(this.row.Status == 'DU') return 'secondary'
            else if(this.row.Status == 'Y') return 'warning'
            else if(this.row.Status == 'DE') return 'success'
            else return 'dark'
        }
    }
}
</script>